import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { useFal } from "../context/FalContext";

const BURCLAR = [
  { isim: "Koç",     baslangic: [3,21], bitis: [4,19],  sembol: "♈", gezegen: "Mars",    element: "Ateş",   renk: "#E05C3A" },
  { isim: "Boğa",    baslangic: [4,20], bitis: [5,20],  sembol: "♉", gezegen: "Venüs",   element: "Toprak", renk: "#F472B6" },
  { isim: "İkizler", baslangic: [5,21], bitis: [6,20],  sembol: "♊", gezegen: "Merkür",  element: "Hava",   renk: "#A8C8A0" },
  { isim: "Yengeç",  baslangic: [6,21], bitis: [7,22],  sembol: "♋", gezegen: "Ay",      element: "Su",     renk: "#C0D0E8" },
  { isim: "Aslan",   baslangic: [7,23], bitis: [8,22],  sembol: "♌", gezegen: "Güneş",   element: "Ateş",   renk: "#F9CB42" },
  { isim: "Başak",   baslangic: [8,23], bitis: [9,22],  sembol: "♍", gezegen: "Merkür",  element: "Toprak", renk: "#A8C8A0" },
  { isim: "Terazi",  baslangic: [9,23], bitis: [10,22], sembol: "♎", gezegen: "Venüs",   element: "Hava",   renk: "#F472B6" },
  { isim: "Akrep",   baslangic: [10,23],bitis: [11,21], sembol: "♏", gezegen: "Mars",    element: "Su",     renk: "#E05C3A" },
  { isim: "Yay",     baslangic: [11,22],bitis: [12,21], sembol: "♐", gezegen: "Jüpiter", element: "Ateş",   renk: "#D4852A" },
  { isim: "Oğlak",   baslangic: [12,22],bitis: [1,19],  sembol: "♑", gezegen: "Satürn",  element: "Toprak", renk: "#8B9DC3" },
  { isim: "Kova",    baslangic: [1,20], bitis: [2,18],  sembol: "♒", gezegen: "Satürn",  element: "Hava",   renk: "#8B9DC3" },
  { isim: "Balık",   baslangic: [2,19], bitis: [3,20],  sembol: "♓", gezegen: "Jüpiter", element: "Su",     renk: "#D4852A" },
];

const GUNLER = ["pazar","pazartesi","sali","carsamba","persembe","cuma","cumartesi"];
const GUN_GEZEGEN = {
  pazar:     { isim: "Güneş",   sembol: "☀️", etki: "Güç, irade ve aydınlanma" },
  pazartesi: { isim: "Ay",      sembol: "🌙", etki: "Sezgi, duygu ve değişim" },
  sali:      { isim: "Mars",    sembol: "♂",  etki: "Cesaret, mücadele ve irade" },
  carsamba:  { isim: "Merkür",  sembol: "☿",  etki: "Zekâ, iletişim ve hız" },
  persembe:  { isim: "Jüpiter", sembol: "♃",  etki: "Bolluk, bilgelik ve şans" },
  cuma:      { isim: "Venüs",   sembol: "♀",  etki: "Aşk, güzellik ve uyum" },
  cumartesi: { isim: "Satürn",  sembol: "♄",  etki: "Sabır, disiplin ve kader" },
};

const burcBul = (tarih) => {
  if (!tarih) return null;
  const [, ay, gun] = tarih.split("-").map(Number);
  for (const b of BURCLAR) {
    const [bA, bG] = b.baslangic;
    const [bitA, bitG] = b.bitis;
    if ((ay === bA && gun >= bG) || (ay === bitA && gun <= bitG)) return b;
  }
  return BURCLAR[11];
};

function ParticleCanvas() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener("resize", resize);
    const particles = Array.from({ length: 80 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      size: Math.random() * 2 + 0.3,
      speedX: (Math.random() - 0.5) * 0.2,
      speedY: -Math.random() * 0.4 - 0.05,
      opacity: Math.random(),
      opSpeed: (Math.random() - 0.5) * 0.008,
      gold: Math.random() > 0.4,
    }));
    let id;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.speedX; p.y += p.speedY;
        p.opacity += p.opSpeed;
        if (p.opacity <= 0 || p.opacity >= 1) p.opSpeed *= -1;
        if (p.y < -5) { p.y = canvas.height + 5; p.x = Math.random() * canvas.width; }
        if (p.x < -5) p.x = canvas.width + 5;
        if (p.x > canvas.width + 5) p.x = -5;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.gold ? `rgba(249,203,66,${p.opacity * 0.8})` : `rgba(255,255,255,${p.opacity * 0.5})`;
        ctx.fill();
      });
      id = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(id); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={canvasRef} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 3 }} />;
}

const SS_KEY = "yildizname_session";

function ssYukle() {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function ssSifirla() {
  sessionStorage.removeItem(SS_KEY);
}

export default function Yildizname() {
  const navigate = useNavigate();
  const { tokenBalance } = useToken();
  const { falGonder } = useFal();

  const ss = ssYukle();

  const [ekran, setEkran] = useState(ss?.ekran ?? "giris");
  const [ad, setAd] = useState(ss?.ad ?? "");
  const [dogumTarihi, setDogumTarihi] = useState(ss?.dogumTarihi ?? "");
  const [niyet, setNiyet] = useState(ss?.niyet ?? "");
  const [sonuc, setSonuc] = useState(ss?.sonuc ?? null);
  const [hata, setHata] = useState("");
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => { setTimeout(() => setFadeIn(true), 100); }, []);

  // State değiştiğinde sessionStorage'a kaydet (yukleniyor hariç)
  useEffect(() => {
    if (ekran === "yukleniyor") return;
    try {
      sessionStorage.setItem(SS_KEY, JSON.stringify({ ekran, ad, dogumTarihi, niyet, sonuc }));
    } catch { /* quota aşıldıysa sessizce geç */ }
  }, [ekran, ad, dogumTarihi, niyet, sonuc]);

  const burc = burcBul(dogumTarihi);
  const gunAdi = dogumTarihi ? GUNLER[new Date(dogumTarihi).getDay()] : null;
  const gezegen = gunAdi ? GUN_GEZEGEN[gunAdi] : null;

  const yildiznameBak = async () => {
    if (!ad.trim() || !dogumTarihi || !niyet.trim()) return;
    if (tokenBalance < 50) { setHata("Yetersiz token! Yıldızname için 50 🪙 gerekiyor."); return; }
    setEkran("yukleniyor");
    setHata("");

    try {
      const sonucFal = await falGonder({
        falciId: "dervis", falTuru: "yildizname", tokenMiktar: 50,
        fotograflar: [], dogumTarihi, ekNot: `Ad: ${ad} | Niyet: ${niyet}`,
        ad: ad,
        burc: burc?.isim || '',
        soru: niyet,
      });
      if (sonucFal.success) {
        setSonuc(sonucFal.yorum || "Yorumun hazırlanıyor...");
        setEkran("sonuc");
      }
      else { setHata("Yıldızname kaydedilemedi."); setEkran("form"); }
    } catch (err) { setHata("Bağlantı hatası."); setEkran("form"); }
  };

  const inputStil = {
    width: "100%", background: "rgba(10,8,20,0.7)",
    border: "1px solid rgba(249,203,66,0.3)", borderRadius: 12,
    padding: "14px 16px", color: "#fff", fontSize: 14, fontFamily: "Georgia, serif",
  };

  return (
    <div style={{ minHeight: "100vh", maxWidth: 420, margin: "0 auto", position: "relative", overflow: "hidden", fontFamily: "Georgia, serif", background: "#050810" }}>
      <style>{`
        @keyframes yildiz-titreme { 0%,100%{opacity:0.5;transform:scale(1)} 50%{opacity:1;transform:scale(1.4)} }
        @keyframes kayan-yildiz { 0%{transform:translateX(-100px) rotate(-25deg);opacity:0} 10%{opacity:1} 90%{opacity:0.8} 100%{transform:translateX(600px) translateY(80px) rotate(-25deg);opacity:0} }
        @keyframes bulut-kayma { 0%{transform:translateX(-20px);opacity:0.12} 50%{transform:translateX(20px);opacity:0.22} 100%{transform:translateX(-20px);opacity:0.12} }
        @keyframes fade-yukari { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }
        @keyframes parlama { 0%,100%{filter:drop-shadow(0 0 8px rgba(249,203,66,0.4))} 50%{filter:drop-shadow(0 0 28px rgba(249,203,66,0.9))} }
        @keyframes donme { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        * { box-sizing:border-box; margin:0; padding:0; }
        ::-webkit-scrollbar { display:none; }
        input:focus, textarea:focus { outline:none; }
        input[type="date"] { color-scheme:dark; }
      `}</style>

      {/* Arka plan */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 0,
        backgroundImage: "url('/yildizname-bg.png')",
        backgroundSize: "cover", backgroundPosition: "center top",
        filter: ekran === "giris" ? "brightness(0.85)" : "brightness(0.25)",
        transition: "filter 1.2s ease",
      }} />

      {/* Karartma overlay */}
      {ekran !== "giris" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1, background: "linear-gradient(180deg,rgba(5,8,16,0.75) 0%,rgba(5,8,16,0.9) 100%)" }} />
      )}

      {/* Bulutlar */}
      {[{ top: "12%", dur: "14s" }, { top: "52%", dur: "20s", rev: true }].map((b, i) => (
        <div key={i} style={{
          position: "fixed", top: b.top, left: "-10%", width: "120%", height: 180,
          background: "radial-gradient(ellipse at center,rgba(200,170,100,0.1) 0%,transparent 70%)",
          animation: `bulut-kayma ${b.dur} ease-in-out infinite ${b.rev ? "reverse" : ""}`,
          zIndex: 2, pointerEvents: "none",
        }} />
      ))}

      {/* Kayan yıldızlar */}
      {[{ top: "8%", delay: "2s", dur: "12s" }, { top: "28%", delay: "7s", dur: "16s" }, { top: "48%", delay: "12s", dur: "10s" }].map((s, i) => (
        <div key={i} style={{ position: "fixed", top: s.top, left: 0, right: 0, height: 2, zIndex: 2, pointerEvents: "none", overflow: "hidden" }}>
          <div style={{ width: 140, height: 1, background: "linear-gradient(90deg,transparent,rgba(249,203,66,0.85),rgba(255,255,255,0.5),transparent)", animation: `kayan-yildiz ${s.dur} ${s.delay} infinite` }} />
        </div>
      ))}

      {/* Parçacıklar */}
      <div style={{ position: "fixed", inset: 0, zIndex: 3, pointerEvents: "none" }}>
        <ParticleCanvas />
      </div>

      {/* ===== GİRİŞ ===== */}
      {ekran === "giris" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", padding: "0 24px", opacity: fadeIn ? 1 : 0, transition: "opacity 1.8s ease" }}>
          <div style={{ width: "100%", paddingTop: 52 }}>
            <button onClick={() => navigate(-1)} style={{ background: "rgba(0,0,0,0.5)", border: "1px solid rgba(249,203,66,0.3)", borderRadius: 12, padding: "8px 16px", color: "rgba(249,203,66,0.8)", fontSize: 13, cursor: "pointer" }}>← Geri</button>
          </div>

          <div style={{ textAlign: "center", flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 90, height: 90, marginBottom: 28, background: "radial-gradient(circle,rgba(249,203,66,0.25) 0%,transparent 70%)", border: "1px solid rgba(249,203,66,0.4)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40, animation: "parlama 3s ease-in-out infinite" }}>
              🔭
            </div>

            <div style={{ fontSize: 11, letterSpacing: 6, color: "rgba(249,203,66,0.7)", textTransform: "uppercase", marginBottom: 14 }}>✦ Osmanlı Sarayı ✦</div>

            <div style={{ fontSize: 42, fontWeight: 900, color: "#fff", textShadow: "0 0 50px rgba(249,203,66,0.7), 0 2px 20px rgba(0,0,0,0.9)", letterSpacing: 3, marginBottom: 10, lineHeight: 1.1 }}>
              Yıldızname
            </div>

            <div style={{ fontSize: 14, color: "rgba(255,220,120,0.75)", letterSpacing: 1.5, marginBottom: 36, fontStyle: "italic" }}>
              Müneccimbaşı Derviş Efendi
            </div>

            <div style={{ width: 140, height: 1, background: "linear-gradient(90deg,transparent,rgba(249,203,66,0.7),transparent)", marginBottom: 32 }} />

            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", lineHeight: 1.9, textAlign: "center", maxWidth: 270, marginBottom: 44, fontStyle: "italic" }}>
              "Yüzyıllık müneccim geleneğiyle yıldızların dilini okur, kaderinin haritasını çıkarırım."
            </div>

            <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", justifyContent: "center" }}>
              {["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"].map((s, i) => (
                <div key={i} style={{ fontSize: 17, color: "rgba(249,203,66,0.55)", animation: `yildiz-titreme ${2 + (i % 3) * 0.7}s ${i * 0.15}s ease-in-out infinite` }}>{s}</div>
              ))}
            </div>
          </div>

          <div style={{ width: "100%", paddingBottom: 60 }}>
            <button onClick={() => setEkran("form")} style={{
              width: "100%", padding: "18px", borderRadius: 16,
              background: "linear-gradient(135deg,rgba(120,90,15,0.95),rgba(249,203,66,0.85),rgba(120,90,15,0.95))",
              border: "1px solid rgba(249,203,66,0.6)", color: "#1A1000",
              fontSize: 16, fontWeight: 800, cursor: "pointer", letterSpacing: 1,
              boxShadow: "0 0 35px rgba(249,203,66,0.4)", fontFamily: "Georgia, serif",
            }}>
              🔭 Yıldıznameye Bak
            </button>
            <div style={{ textAlign: "center", marginTop: 12, fontSize: 12, color: "rgba(249,203,66,0.5)" }}>50 🪙 token gereklidir</div>
          </div>
        </div>
      )}

      {/* ===== FORM ===== */}
      {ekran === "form" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", paddingBottom: 100, animation: "fade-yukari 0.6s ease backwards" }}>
          <div style={{ padding: "52px 24px 20px", display: "flex", alignItems: "center", gap: 14 }}>
            <button onClick={() => setEkran("giris")} style={{ background: "rgba(0,0,0,0.5)", border: "1px solid rgba(249,203,66,0.3)", borderRadius: 12, padding: "8px 16px", color: "rgba(249,203,66,0.8)", fontSize: 13, cursor: "pointer" }}>← Geri</button>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>Yıldızname</div>
              <div style={{ fontSize: 11, color: "rgba(249,203,66,0.6)" }}>Derviş Efendi'ye sor</div>
            </div>
            <div style={{ marginLeft: "auto", fontSize: 12, color: "#F9CB42", fontWeight: 700 }}>🪙 {tokenBalance}</div>
          </div>

          <div style={{ margin: "0 24px 24px", height: 1, background: "linear-gradient(90deg,transparent,rgba(249,203,66,0.4),transparent)" }} />

          <div style={{ padding: "0 24px" }}>
            {tokenBalance < 50 && (
              <div onClick={() => navigate("/token-kazan")} style={{ marginBottom: 20, padding: "14px 16px", borderRadius: 14, background: "rgba(239,68,68,0.2)", border: "1px solid rgba(239,68,68,0.4)", color: "#FCA5A5", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span>⚠️ Yetersiz token! {tokenBalance} 🪙 mevcut</span>
                <span style={{ color: "#F472B6", fontWeight: 700 }}>Token Al →</span>
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: "rgba(249,203,66,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>✦ Adın</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>Kulağına okunan ad — Müneccim seni bu adla çağıracak</div>
              <input type="text" value={ad} onChange={e => setAd(e.target.value)} placeholder="Adını yaz..." style={inputStil} />
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: "rgba(249,203,66,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>✦ Doğum Tarihin</div>
              <input type="date" value={dogumTarihi} onChange={e => setDogumTarihi(e.target.value)} style={inputStil} />
            </div>

            {burc && gezegen && (
              <div style={{ marginBottom: 20, padding: "16px", background: "rgba(249,203,66,0.06)", border: "1px solid rgba(249,203,66,0.25)", borderRadius: 14, animation: "fade-yukari 0.4s ease backwards", display: "flex", alignItems: "center", gap: 16 }}>
                <div style={{ textAlign: "center", flexShrink: 0 }}>
                  <div style={{ fontSize: 28, color: burc.renk }}>{burc.sembol}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>{burc.isim}</div>
                </div>
                <div style={{ width: 1, height: 44, background: "rgba(249,203,66,0.2)", flexShrink: 0 }} />
                <div>
                  <div style={{ fontSize: 12, color: "#F9CB42", fontWeight: 700 }}>{gezegen.sembol} Doğum Gezegeni: {gezegen.isim}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 3 }}>{gezegen.etki}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>Element: {burc.element} · Hâkim: {burc.gezegen}</div>
                </div>
              </div>
            )}

            <div style={{ marginBottom: 28 }}>
              <div style={{ fontSize: 11, color: "rgba(249,203,66,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>✦ Niyetin</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>Kalbinde ne soruyor, yıldızlardan ne öğrenmek istiyorsun?</div>
              <textarea value={niyet} onChange={e => setNiyet(e.target.value)} placeholder="Müneccim Efendi'ye sor..." rows={4} style={{ ...inputStil, resize: "none", lineHeight: 1.6 }} />
            </div>

            {hata && (
              <div style={{ marginBottom: 16, padding: "12px 16px", borderRadius: 12, background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#FCA5A5", fontSize: 13 }}>
                ⚠️ {hata}
              </div>
            )}

            <button onClick={yildiznameBak} disabled={!ad.trim() || !dogumTarihi || !niyet.trim() || tokenBalance < 50} style={{
              width: "100%", padding: "18px", borderRadius: 16, fontSize: 16, fontWeight: 800, cursor: "pointer", fontFamily: "Georgia, serif", letterSpacing: 0.5,
              background: !ad.trim() || !dogumTarihi || !niyet.trim() || tokenBalance < 50 ? "rgba(255,255,255,0.06)" : "linear-gradient(135deg,rgba(100,75,10,0.95),rgba(249,203,66,0.85),rgba(100,75,10,0.95))",
              border: !ad.trim() || !dogumTarihi || !niyet.trim() || tokenBalance < 50 ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(249,203,66,0.5)",
              color: !ad.trim() || !dogumTarihi || !niyet.trim() || tokenBalance < 50 ? "rgba(255,255,255,0.3)" : "#1A1000",
              boxShadow: ad.trim() && dogumTarihi && niyet.trim() && tokenBalance >= 50 ? "0 0 28px rgba(249,203,66,0.35)" : "none",
            }}>
              🔭 Yıldıznameye Bak — 🪙 50
            </button>
          </div>
        </div>
      )}

      {/* ===== YÜKLENİYOR ===== */}
      {ekran === "yukleniyor" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "0 32px", textAlign: "center" }}>
          <div style={{ fontSize: 70, marginBottom: 32, animation: "donme 8s linear infinite", filter: "drop-shadow(0 0 24px rgba(249,203,66,0.7))" }}>🔭</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Yıldızlar okunuyor...</div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", lineHeight: 1.8, fontStyle: "italic" }}>
            Derviş Efendi gökyüzündeki<br />işaretleri yorumluyor
          </div>
          <div style={{ display: "flex", gap: 14, marginTop: 40 }}>
            {["♈","♎","♌"].map((s, i) => (
              <div key={i} style={{ fontSize: 26, color: "rgba(249,203,66,0.6)", animation: `yildiz-titreme 1.5s ${i * 0.3}s ease-in-out infinite` }}>{s}</div>
            ))}
          </div>
        </div>
      )}

      {/* ===== SONUÇ ===== */}
      {ekran === "sonuc" && sonuc && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", paddingBottom: 100, animation: "fade-yukari 0.8s ease backwards" }}>
          <div style={{ padding: "52px 24px 20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.4)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, animation: "parlama 3s ease-in-out infinite" }}>🔭</div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>Müneccimbaşı Derviş Efendi</div>
                <div style={{ fontSize: 11, color: "rgba(249,203,66,0.6)" }}>Osmanlı Sarayı Baş Müneccimi</div>
              </div>
            </div>

            {burc && (
              <div style={{ padding: "12px 16px", borderRadius: 14, background: "rgba(249,203,66,0.06)", border: "1px solid rgba(249,203,66,0.2)", display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 22, color: burc.renk }}>{burc.sembol}</span>
                <div>
                  <div style={{ fontSize: 13, color: "#F9CB42", fontWeight: 700 }}>{ad} · {burc.isim}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{gezegen?.sembol} {gezegen?.isim} · {burc.element} · {burc.gezegen}</div>
                </div>
              </div>
            )}
          </div>

          <div style={{ margin: "0 24px 24px", height: 1, background: "linear-gradient(90deg,transparent,rgba(249,203,66,0.5),transparent)" }} />

          <div style={{ padding: "0 24px" }}>
            <div style={{ fontSize: 11, color: "rgba(249,203,66,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 16 }}>✦ Yıldızname Yorumu</div>
            <div style={{ background: "rgba(10,8,20,0.8)", border: "1px solid rgba(249,203,66,0.2)", borderRadius: 20, padding: "24px" }}>
              <div style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.9, fontStyle: "italic", whiteSpace: "pre-wrap" }}>
                {sonuc}
              </div>
            </div>

            <button onClick={async () => {
              const metin = `🔭 Müneccimbaşı Derviş Efendi'den Yıldızname Yorumum:\n\n"${sonuc}"\n\n✨ Remil'de yıldıznameye bak → https://www.remil.app`;
              if (navigator.share) { try { await navigator.share({ title: "Yıldızname", text: metin }); } catch (e) {} }
              else { navigator.clipboard.writeText(metin); alert("Kopyalandı!"); }
            }} style={{ width: "100%", padding: "14px", borderRadius: 14, marginTop: 16, background: "rgba(249,203,66,0.08)", border: "1px solid rgba(249,203,66,0.25)", color: "rgba(249,203,66,0.8)", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "Georgia, serif" }}>
              📤 Yıldıznameyi Paylaş
            </button>

            <button onClick={() => { ssSifirla(); navigate("/"); }} style={{ width: "100%", padding: "14px", borderRadius: 14, marginTop: 10, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.4)", fontSize: 13, cursor: "pointer" }}>
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
      )}
    </div>
  );
}